<template>
  <div class="card-right">
    <div v-if="isOpen === 1" class="card-content">
      <div class="card-header">
        <h2>{{ $t('preApprovalLogin.companyDetails') }}</h2>
        <p>{{ $t('preApprovalLogin.description') }}</p>
        <lls-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-position="top"
          class="demo-ruleForm"
        >
          <lls-form-item :label="$t('preApprovalLogin.monthlySales')" prop="monthlySales">
            <lls-select v-model="ruleForm.monthlySales" clearable filterable :placeholder="$t('preApprovalLogin.select')">
              <lls-option
                v-for="item in monthlySalesList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></lls-option>
            </lls-select>
          </lls-form-item>
          <lls-form-item :label="$t('preApprovalLogin.businessScope')" prop="businessScope">
            <lls-select v-model="ruleForm.businessScope" clearable filterable :placeholder="$t('preApprovalLogin.select')">
              <lls-option
                v-for="item in businessScopeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></lls-option>
            </lls-select>
          </lls-form-item>
          <lls-form-item>
            <lls-button
              type="primary"
              @click="submitForm('ruleForm')"
              class="next-btn"
              :loading="btnLoading"
              style="margin-top: 5px;"
            >{{ $t('preApprovalLogin.next') }}</lls-button>
          </lls-form-item>
        </lls-form>
      </div>
    </div>
    <div v-else class="card-bottom">
      <div class="card-info">
        <p class="title success">
          <span>
            <i class="lls-icon-success"></i> {{ $t('preApprovalLogin.companyDetails') }}
          </span>
          <i class="lls-icon-edit-outline" @click="handleOpen"></i>
        </p>
        <p class="tip">{{ companyNameCn }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { filterDictParam } from '@/common/util.js'
export default {
  props: {
    isOpen: {
      type: [Number, String],
    },
  },
  data() {
    return {
      ruleForm: {
        monthlySales: '',
        businessScope: '',
      },
      rules: {
        monthlySales: [
          {
            required: true,
            message: this.$t('preApprovalLogin.monthlySalesMiss'),
            trigger: 'change',
          },
        ],
        businessScope: [
          {
            required: true,
            message: this.$t('preApprovalLogin.businessScopeMiss'),
            trigger: 'change',
          },
        ],
      },
      monthlySalesList: [],
      businessScopeList: [],
      btnLoading: false,
      companyNameCn: '',
    }
  },
  async mounted() {
    await this.getEnum()
    await this.checkInitInfo()
  },
  methods: {
    handleOpen() {
      this.$emit('open')
      this.getInitInfo()
    },
    async getInitInfo() {
      try {
        const res = await this.$API.system.getCorpInfo()
        const { monthlySales, businessScope, companyNameCn } =
          res.data?.data || {}
        this.companyNameCn = companyNameCn
        if (monthlySales && businessScope) {
          this.ruleForm = {
            monthlySales: filterDictParam(monthlySales),
            businessScope: filterDictParam(businessScope),
          }
        }
        return { monthlySales, businessScope }
      } catch (err) {
        return {}
      }
    },
    async checkInitInfo() {
      const { monthlySales, businessScope } = await this.getInitInfo()
      this.$emit('done', monthlySales && businessScope)
    },
    async getEnum() {
      await Promise.all([
        this.$API.system.queryList({ enumType: 'MonthlySalesEnum' }),
        this.$API.system.queryList({ enumType: 'BusinessScopeEnum' }),
      ])
        .then((responses) => {
          this.monthlySalesList = responses[0].data.data
          this.businessScopeList = responses[1].data.data
        })
        .catch((err) => {})
    },
    submitForm(refName) {
      this.$refs[refName].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          this.$API.system
            .updateByEnterpriseId(this.ruleForm)
            .then((res) => {
              this.$message.success(this.$t('preApprovalLogin.success'))
              this.$emit('next')
            })
            .catch((err) => {})
            .finally(() => {
              this.btnLoading = false
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.card-header {
  p {
    color: #99a3b1;
    font-size: 12px;
    padding: 13px 0 14px 0;
  }

  h2 {
    color: #4e78b1;
    font-weight: 600;
    font-size: 16px;
  }

  .next-btn {
    width: 100%;
  }
}
.card-bottom {
  .card-info {
    .title {
      color: #8b97a8;
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 10px;

      &.success {
        color: #4e78b1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .lls-icon-success {
          color: #06d6a0;
        }
        .lls-icon-edit-outline {
          font-size: 22px;
          color: #c4c4c4;
          cursor: pointer;
          position: absolute;
          right: 30px;
          top: 30px;
        }
      }
    }
    .tip {
      color: #8c8c8c;
      font-size: 12px;
    }
  }
}
::v-deep {
  .lls-select {
    width: 100%;
  }
  .lls-form-item {
    margin-bottom: 18px;
  }
}
</style>
